import packageJson from '../../package.json';

export const GetVersionCode = () => {
    try {
      return packageJson.version;
    } catch (error) {
      console.error('Error al leer package.json:', error);
      return 'Versión no encontrada';
    }
  }
  
//module.exports = packageJson.version;
